export const ultimasNoticias = [

    /* aqui si no tienes avisos todo dejalo como comentario, aqui es donde se pone los anuncios de los concursos de transparencia */

 /*   {
        "imagen" : "https://cdn.hidalgo.gob.mx/transicion/feria.png",
        "url" : "www.gooogle.com",
        "titulo" : "Aqui va el titulo 1",
        "fecha" : "02 de marzo del 2023"
    },
    {
        "imagen" : "https://cdn.hidalgo.gob.mx/transicion/feria.png",
        "url" : "www.gooogle.com",
        "titulo" : "Aqui va el titulo 2",
        "fecha" : "02 de marzo del 2023"
    
    },

    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria//Normatividad/Ligas/OfertaLaboral.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Normatividad/Ligas/OfertaLaboral.png",
        "titulo" : "Oferta Laboral",
        "fecha" : "Reclutamiento y Selección de Personal 771 107 1091 Extensión 135 / 771 179 55 52"
    },
    {
        "imagen" : "https://cdn.hidalgo.gob.mx/convocatorias/2024/convocatoria1.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/2025/48rubros/1erTrimestre/fraccion15a/TC_Conv%20Nal_HGO.pdf",
        "titulo" : "XIX Concurso Nacional de Transparencia en Corto",
        "fecha" : "“Uso de las tecnologías de la información y su impacto en la cultura de la transparencia y la rendición de cuentas"
    },*/
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria//Normatividad/Ligas/Contratacion.png",
        "url" : "https://ruts.hidalgo.gob.mx/ver/9789",
        "titulo" : "Servicio de protección, custodia, vigilancia y traslado",
        "fecha" : "Salvaguardar la integridad y bienes de las personas físicas y morales, públicas y privadas."
    }
    
]